import { ActionType, getType } from 'typesafe-actions';

import * as actions from './actions';

export interface IRulesState {
  readonly index: number;
  readonly opacity: boolean;
}

export type RulesActions = ActionType<typeof actions>;

const initialState: IRulesState = {
  index: 0,
  opacity: true
};

export default (state = initialState, action: RulesActions): IRulesState => {
  switch (action.type) {
    case getType(actions.changeRules): {
      return {
        ...state,
        index: action.payload
      };
    }
    case getType(actions.setOpacity): {
      const newState = {
        ...state,
        opacity: action.payload
      };
      return newState;
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/rules/reducer.ts